import React, { Component } from "react";
import "../../styles/operator.css";
import { withRouter } from "react-router-dom";
import styles from "../../styles/operatorHomeStyle";
import HocComponent from '../../commonComponents/Hoc';
import {
  Text,
  View,
  ScrollView,
  Button,
  Image,
  TextInput,
  TouchableOpacity,
} from "react-native";
import { LOGIN_PATH } from "../../constants/routePaths";
import {
  agentTyping,
  connectToSocket,
  disconnectSocket,
  sendMessage,
} from "../../services/socket/operator-service";
import {
  SESSION_EXPIRY,
  SESSION_TOKEN,
  SOCKET_EVENTS,
  TYPE_PLACEHOLDER,
} from "../../constants/textConstants";
import ChatContainer from "../../commonComponents/Chats";
import CustomersConnected from "./CustomersConnected";
import QuickChatBox from "./QuickChatBox";
let socket;
const isScreenSizeNotWeb = window.innerWidth <= 768 ? true : false;

class Operator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      enteredMessage: "",
      current_message: "",
      users: [],
      room: "",
      operatorMode: false,
      allRooms: {},
      dummyName: "",
      AllDetailsRooms: {},
      allWhatsappUsers: {},
      showSideBar: isScreenSizeNotWeb ? false : true,
      showChatContainer: true,
    };
  }

  //logout method
  onPressLogout = () => {
    localStorage.clear();
    this.props.history.push(LOGIN_PATH);
  };

  //on screen load method
  componentDidMount() {
    if (!localStorage.getItem(SESSION_TOKEN)) {
      return this.props.history.push({
        pathname: LOGIN_PATH,
      });
    }
    socket = connectToSocket();
    this.listenToMessages(socket);
    this.removeOnDisconnect(socket);

    //on unauthenticated tokens
    socket.on(SOCKET_EVENTS.CONNECT_ERROR, () => {
      alert(SESSION_EXPIRY);
      socket.disconnect();
      this.onPressLogout();
    });


    window.addEventListener('resize', this.updateSize);
  }

  updateSize = () => {
    if (window.innerWidth <= 768) {
      this.setState({ showSideBar: false, showChatContainer: true })
    } else {
      this.setState({ showSideBar: true, showChatContainer: true })
    }
  }

  //on chat selection
  onSelectChat = (roomId) => {
    const isScreenSizeNotWeb = window.innerWidth <= 768 ? true : false;
    const messages = this.state.AllDetailsRooms[roomId].messages;
    this.setState({
      showSideBar: isScreenSizeNotWeb ? false : true,
      showChatContainer: true,
      room: roomId,
      messages,
      enteredMessage: "",
    });
  };

  //listen to all messages
  listenToMessages = (socketClient) => {
    socketClient.on(SOCKET_EVENTS.OPERATOR_MESSAGES, (data) => {
      let { room, messages, AllDetailsRooms } = this.state;
      data.chats.map((item) => {
        room = room ? room : item.customer_id;

        messages = (room === item.customer_id)
          ? item.MessageModels.map((each) => JSON.parse(each.message))
          : messages;

        AllDetailsRooms = {
          ...AllDetailsRooms,
          [item.customer_id]: {
            messages: item.MessageModels
              ? item.MessageModels.map((each) => JSON.parse(each.message))
              : [],
            customerId: item.customer_id ? item.customer_id : "",
            isAgentConnectedToCustomer: item.is_agent_connected,
            isAgentHandOff: item.agent_handoff,
            customerName: item.customer_name,
            createdAt: item.createdAt,
            reason: item.reason ? item.reason : "",
          },
        }
        this.setState({
          room, messages, AllDetailsRooms
        })
      });
    });
  };

  //on cutomer logs off
  removeOnDisconnect = (socketClient) => {
    socketClient.on(SOCKET_EVENTS.CUSTOMER_DISCONNECT, (customerId) => {
      let { AllDetailsRooms, room, messages } = this.state;
      delete AllDetailsRooms[customerId];
      if (room === customerId) {
        let firstChat = Object.keys(AllDetailsRooms)[0];
        room = firstChat ? firstChat : "";
        messages = AllDetailsRooms[firstChat]
          ? AllDetailsRooms[firstChat].messages
          : [];
      }

      this.setState({
        AllDetailsRooms,
        room,
        messages,
        enteredMessage: "",
      });
    });
  };

  //on screen change or refresh or closed
  UNSAFE_componentWillMount() {
    disconnectSocket();
  }

  //on enter pressed
  onEnter = async (event) => {
    if (event.nativeEvent.key == "Enter") {
      event.preventDefault();
      this.sendMessageFromInput();
    }
  };

  //send message fron input
  sendMessageFromInput = () => {
    if (this.state.enteredMessage) {
      this.updateSentMessage(this.state.enteredMessage);
    }
  };
  onClickQuickmessages = (msg) => {
    this.setState({
      enteredMessage: msg,
    });
  };

  //update messages and send to socket
  updateSentMessage = (value) => {
    const messageObj = sendMessage(value, this.state.room);
    this.setState({
      messages: [...this.state.messages, messageObj],
      enteredMessage: "",
    });
    agentTyping(false, this.state.room);
  };

  //on message change
  onChangeMessage(env) {
    this.setState({ enteredMessage: env.target.value });
    if (
      this.state.AllDetailsRooms[this.state.room] &&
      this.state.AllDetailsRooms[this.state.room].isAgentConnectedToCustomer
    ) {
      agentTyping(
        (env.target.value && env.target.value.length) > 0,
        this.state.room
      );
    }
  }
  onPressCloseBtn = () => {
    this.setState({ showSideBar: false, showChatContainer: true });
  }
  onPressMenu = () => {
    this.setState({ showSideBar: true, showChatContainer: false });
  }
  //render ui
  render() {
    const isScreenSizeNotWeb = window.innerWidth <= 768 ? true : false;

    const { showSideBar, showChatContainer } = this.state;
    const sideBarResponsive = `sideBar_${this.props.measure}`;
    const chatContainer = `chatbox_${this.props.measure}`;
    const sendBoxResponsive = `sendBox_${this.props.measure}`;


    return (
      <View style={{ display: "flex", flexDirection: "row", width: "100%", }}>
        {showSideBar && <View style={[styles.sideBar, styles[sideBarResponsive]]}>
          {/* <Image
            style={styles.wnsLogo}
            source={require("../../../assets/images/logo.png")}
          ></Image>
          <View style={styles.line}></View> */}
          {isScreenSizeNotWeb &&
            <View style={styles.closeIconView}>
              <TouchableOpacity onPress={() => this.onPressCloseBtn()}><Image style={styles.closeIcon} source={require("../../../assets/images/closeIcon.png")} /></TouchableOpacity>
            </View>
          }
          <View style={styles.sideBarHeading}>
            <Text style={styles.sidebarTxtHeading}>Customers</Text>
          </View>

          <ScrollView>
            <CustomersConnected
              room={this.state.room}
              AllDetailsRooms={this.state.AllDetailsRooms}
              onSelectChat={this.onSelectChat}
            />
          </ScrollView>

          <View style={styles.logoutView}>
            <TouchableOpacity
              onPress={() => this.onPressLogout()}
              style={styles.row}
            >
              <Image
                style={styles.logout}
                source={require("../../../assets/images/logout.png")}
              ></Image>
              <Text style={styles.logoutText}>Logout</Text>
            </TouchableOpacity>
          </View>
        </View>
        }
        {(isScreenSizeNotWeb && showChatContainer) && <View style={styles.menuView}>
          <TouchableOpacity onPress={() => this.onPressMenu()}><Image style={styles.menuIcon} source={require("../../../assets/images/menu.png")} /></TouchableOpacity>
        </View>
        }
        {showChatContainer &&
          <View style={[styles.chatContainer, styles[chatContainer]]}>



            <ChatContainer
              loginType="bot"
              messages={this.state.messages}
              setHomeStates={() => { }}
            />
            <View style={[styles.sendBox, styles[sendBoxResponsive]]}>
              <TextInput
                ref={(input) => {
                  this.inputTextFocus = input;
                }}
                placeholder={TYPE_PLACEHOLDER}
                style={
                  global.platform === "web"
                    ? [styles.inputText, { outline: "none" }]
                    : [styles.inputText]
                }
                value={this.state.enteredMessage}
                multileditable={true}
                multiline={true}
                onChange={(env) => this.onChangeMessage(env)}
                placeholderTextColor="#d6d6d6"
                onKeyPress={(e) => this.onEnter(e)}
                disabled={
                  !this.state.AllDetailsRooms[this.state.room] ||
                  !this.state.AllDetailsRooms[this.state.room]
                    .isAgentConnectedToCustomer
                }
              />

              <TouchableOpacity
                onPress={this.sendMessageFromInput}
                disabled={
                  !this.state.AllDetailsRooms[this.state.room] ||
                  !this.state.AllDetailsRooms[this.state.room]
                    .isAgentConnectedToCustomer
                }
                style={styles.sendView}
              >
                <Image
                  style={styles.send}
                  source={require("../../../assets/images/sendOperatorMsg.png")}
                ></Image>
              </TouchableOpacity>
            </View>
            <QuickChatBox
              room={this.state.room}
              AllDetailsRooms={this.state.AllDetailsRooms}
              onClickQuickmessages={this.onClickQuickmessages}
            />
          </View>
        }
      </View>
    );
  }
}

export default HocComponent(Operator);
